var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    d: "M15.958 6.046a.86.86 0 0 0-.732-.61l-4.618-.438L8.782.538A.85.85 0 0 0 8 0a.85.85 0 0 0-.782.54L5.392 4.997l-4.619.438a.86.86 0 0 0-.731.61.91.91 0 0 0 .249.943l3.49 3.194-1.03 4.732a.91.91 0 0 0 .332.916.82.82 0 0 0 .934.043L8 13.388l3.982 2.484a.82.82 0 0 0 .935-.042.91.91 0 0 0 .33-.916l-1.029-4.732 3.49-3.194a.91.91 0 0 0 .25-.943"
  })));
};
var Memo = /*#__PURE__*/memo(SvgStar);
export default Memo;